<script>
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Alert
    } from 'sveltestrap';
  import { navigate } from 'svelte-routing';
  import { api_url, path, errorColor } from "../ConfigService.js";

  export let orderno;
  export let token;
  export let data;
  export let open = false;
  const toggle = () => (selectedFile = !selectedFile);

  async function deleteOrder() {
  	const resp = await fetch($api_url+'deleteOrder.php?orderno='+orderno+'&token='+token)
  	open = false;
	data = await resp.json();
	navigate('/');
  }

  function closeDeleteDialog() { open=false; }
</script>

<Modal isOpen={open} {toggle}>
    <ModalHeader {toggle}>Odstranění zakázky</ModalHeader>
    <ModalBody>
      <h3>Opravdu chcete tuto zakázku?</h3>
      <br />
      <ul style="list-style-type:disc;font-weight:bold;">
      	<li>Již nebude možné objednat fotografie z této zakázky.</li>
      	<li>Uskutečněné objednávky budou zpracovány.</li>
      </ul><br />
    </ModalBody>
    <ModalFooter>
      <Button color="danger" on:click="{()=>deleteOrder()}">Odstranit zakázku</Button>
      <Button color="secondary" on:click={()=>closeDeleteDialog()}>Zrušit</Button>
    </ModalFooter>
 </Modal>
